module.exports = __webpack_public_path__ + "static/media/maze.12c141ff.mp3";